import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  //   TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Checkbox,
  ListItemText,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import usePageTitle from "app/pageTitle";

import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";
import DataTable from "theme/Tables/DataTable";
import axios from "axios.js";
// import AppConfig from "appConfig";

function ShippingRatesPage() {
  const pageTitle = "Shipping Rates";
  usePageTitle(pageTitle);
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);

  const [shippingRates, setShippingRates] = useState([]);
  const [openCreateShippingRateDialog, setOpenCreateShippingRateDialog] = useState(false);
  const [title, setTitle] = useState(null);
  const [campaigns, setCampaigns] = useState([]);
  const [selectedShippingRate, setSelectedShippingRate] = useState(null);
  const [selectedCampaigns, setSelectedCampaigns] = useState([]);
  const [openAttachDialog, setOpenAttachDialog] = useState(false);
  const [selectAllCampaigns, setSelectAllCampaigns] = useState(false);

  async function updateCollectionStatus(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/shipping_rates/${ref}/status/update.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteCollection(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/shipping_rates/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const ratesTableColumns = [
    { Header: "Collection", accessor: "name", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Actions", accessor: "actions", align: "right" },
    // { Header: "Added On", accessor: "created", align: "center" },
  ];

  const buildRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        name: row.title,
        status: (
          <MDBox>
            <Icon color={row.status ? "success" : "error"}>
              {row.status ? "check_circle" : "cancel"}
            </Icon>
          </MDBox>
        ),
        actions: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="outlined"
              color="info"
              iconOnly
              onClick={() => {
                setSelectedCampaigns([]);
                setSelectedShippingRate(row.reference);
                setOpenAttachDialog(true);
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                move_up
              </Icon>
            </MDButton>
            &nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="warning"
              iconOnly
              onClick={() => {
                navigate(`/shipping-fees/${row.reference}`);
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                edit
              </Icon>
            </MDButton>
            &nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="info"
              iconOnly
              onClick={() => {
                if (
                  window.confirm(`${row.status ? "Disable" : "Enable"} this collection?`) === true
                ) {
                  updateCollectionStatus(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                {row.status ? "pause" : "play_arrow"}
              </Icon>
            </MDButton>
            &nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Delete?`) === true) {
                  deleteCollection(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
        // created: row.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/shipping_rates.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            // console.log(result.data.data);
            setCampaigns(result.data.data.campaigns);
            const rows = buildRows(result.data.data.shipping_rates);
            setShippingRates(rows);
            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function createCollection() {
    if (title === null) {
      setSeverity("error");
      setErrMsg("Collection name is required.");
      setOpen(true);
      return;
    }

    setOpenCreateShippingRateDialog(false);
    setShowLoading(true);
    const json = {
      title: `${title}`,
    };

    await axios
      .post("portal/shipping_rates/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  useEffect(() => {
    if (!selectAllCampaigns) {
      setSelectedCampaigns([]);
      return;
    }

    if (campaigns.length <= 0) {
      return;
    }

    const tempArry = [];
    campaigns.every((row) => {
      tempArry.push(row.reference);
      return true;
    });

    setSelectedCampaigns(tempArry);
  }, [selectAllCampaigns]);

  async function attachToCampaigns() {
    if (selectedCampaigns.length <= 0) {
      setSeverity("error");
      setErrMsg("Please select a campaign.");
      setOpen(true);
      return;
    }

    if (selectedShippingRate === null) {
      setSeverity("error");
      setErrMsg("Shipping collection is required");
      setOpen(true);
      return;
    }

    setOpenAttachDialog(false);
    setShowLoading(true);

    const json = {
      shipping_rate: selectedShippingRate,
      campaigns: selectedCampaigns,
    };

    await axios
      .post("portal/shipping_rates/campaigns/attach.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      <Dialog open={openCreateShippingRateDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>New Shipping Fees</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox>
              <MDInput
                value={title}
                name="title"
                margin="dense"
                label="Collection Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setTitle(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenCreateShippingRateDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              createCollection();
            }}
          >
            Create
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openAttachDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Attach To Campaigns</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={1}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Select Campaign(s)</InputLabel>
                <Select
                  multiple
                  value={selectedCampaigns}
                  label="Select Campaign(s)"
                  // onChange={handleChange}
                  onChange={(e) => {
                    setSelectedCampaigns(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                  // renderValue={(selected) => selected.join(", ")}
                  renderValue={(selected) => {
                    let renderString = "";
                    selected.every((ref) => {
                      campaigns.every((row) => {
                        if (row.reference === ref) {
                          renderString += `${row.title}, `;
                          return false;
                        }
                        return true;
                      });
                      return true;
                    });

                    return renderString.replace(/, +$/, "");
                  }}
                >
                  {
                    // --> Notice below changes
                    campaigns.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      campaigns.map((record) => (
                        <MenuItem value={record.reference}>
                          <Checkbox checked={selectedCampaigns.indexOf(record.reference) > -1} />
                          <ListItemText
                            primary={
                              <MDTypography variant="caption" fontSize={14}>
                                {record.title}
                              </MDTypography>
                            }
                          />
                        </MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
            <MDBox mt={3} display="flex" alignItems="center" ml={-1}>
              <Checkbox
                checked={selectAllCampaigns}
                onChange={(e) => {
                  setSelectAllCampaigns(e.target.checked);
                }}
              />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Select All Campaigns?
              </MDTypography>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAttachDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              attachToCampaigns();
            }}
          >
            Attach
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox pt={3} pb={3}>
        {pageLoaded && (
          <MDBox>
            <MDBox>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox p={0}>
                  <MDBox align="center">
                    <MDBox>
                      <MDTypography variant="h6" fontSize={48}>
                        <Icon>local_shipping</Icon>
                      </MDTypography>
                      <MDTypography variant="h6" fontWeight="bold" fontSize={16}>
                        Shipping Fees
                      </MDTypography>
                      <MDTypography mt={1} variant="h6" fontWeight="light" fontSize={14}>
                        Need to ship physical products to your customers? Set up your shipping rates
                        and fees by country, state, city or location.
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={5} mb={3}>
                      <MDButton
                        variant="contained"
                        color="dark"
                        onClick={() => {
                          setTitle(null);
                          setOpenCreateShippingRateDialog(true);
                        }}
                        startIcon={<Icon>add</Icon>}
                      >
                        Add Collection
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            {shippingRates.length > 0 && (
              <MDBox mt={5}>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox>
                    <MDBox p={2}>
                      <MDBox display="flex" justifyContent="space-between" alignItems="center">
                        <MDBox>
                          <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                            Shipping Fees Collections
                          </MDTypography>
                        </MDBox>
                        {/* <MDBox display="flex" justifyContent="space-evenly" alignItems="end">
                          <MDBox>
                            <MDButton
                              variant="contained"
                              color="dark"
                              iconOnly
                              onClick={() => {
                                setTitle(null);
                                setOpenCreateShippingRateDialog(true);
                              }}
                            >
                              <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                            </MDButton>
                          </MDBox>
                        </MDBox> */}
                      </MDBox>
                    </MDBox>
                    <MDBox p={0}>
                      <DataTable
                        table={{ columns: ratesTableColumns, rows: shippingRates }}
                        isSorted
                        entriesPerPage
                        showTotalEntries
                        buttons
                        noEndBorder
                      />
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
            )}
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ShippingRatesPage;
